
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 8">
  <path
    d="M13.5303 6.806L12.4698 7.8665L7.0001 2.3975L1.53035 7.86725L0.469849 6.80675L7.0001 0.275749L13.5303 6.806Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'ArrowUp',
    }) as DefineComponent
    </script>
    